import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {DepartmentPage} from "../page/overview/department/department.page";
import {EmployeePage} from "../page/overview/employee/employee.page";
import {OrganizationUnitPage} from "../page/overview/organization-unit/organization-unit.page";


const omModuleEntry: TestModuleDefinition = {
    key: 'om',
    label: 'Organization (om)',
    components: [
        {
            key: 'DepartmentPage',
            component: DepartmentPage,
            selector: 'mvs-om-department-page',
            type: 'PageComponent',
            label: 'om department page'
        },
        {
            key: 'EmployeePage',
            component: EmployeePage,
            selector: 'mvs-om-employee-page',
            type: 'PageComponent',
            label: 'om employee page'
        },
        {
            key: 'OrganizationUnitPage',
            component: OrganizationUnitPage,
            selector: 'mvs-om-organization-unit-page',
            type: 'PageComponent',
            label: 'om organization unit page'
        },
    ]
}

export const OM_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: omModuleEntry, multi: true}
];